import React from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";

const ProfileView = () => {
  const { user } = useSelector((state) => ({
    user: state.auth.user,
  }));

  // Extract initials from user name (e.g., "Kanha Gentleman" -> "KG")
  const getInitials = (name) => {
    if (!name) return "A";
    const parts = name.trim().split(/\s+/);
    if (parts.length > 1) {
      return (parts[0][0] + parts[1][0]).toUpperCase();
    }
    return parts[0][0].toUpperCase();
  };

  return (
    <div className="sidebar-profile-card" style={{ padding: "5px 15px 15px 15px", textAlign: "center" }}>
      <Link to="/profile" style={{ display: "inline-block", position: "relative", marginBottom: "8px", textDecoration: "none" }}>
        {user && user.image ? (
          <img 
            alt="profile" 
            src={user.image} 
            style={{ 
              width: "70px", 
              height: "70px", 
              borderRadius: "50%",
              border: "2px solid rgba(255, 255, 255, 0.15)",
              boxShadow: "0 4px 10px rgba(0, 0, 0, 0.15)",
              display: "block"
            }} 
          />
        ) : (
          <div style={{
            width: "70px",
            height: "70px",
            borderRadius: "50%",
            backgroundColor: "#2f7edc",
            color: "#ffffff",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: "24px",
            fontWeight: "600",
            border: "2px solid rgba(255, 255, 255, 0.15)",
            boxShadow: "0 4px 10px rgba(0, 0, 0, 0.15)",
            margin: "0 auto"
          }}>
            {getInitials(user?.name || "Admin")}
          </div>
        )}
      </Link>
      <div className="profile-info" style={{ marginTop: "4px" }}>
        <Link to="/profile" style={{ textDecoration: "none" }}>
          <h3 className="user-name" style={{ color: "#ffffff", fontSize: "15px", fontWeight: "600", margin: "0" }}>
            {user?.name || "Admin"}
          </h3>
        </Link>
        <span className="text-muted" style={{ fontSize: "12px", color: "#94a3b8", display: "block", marginTop: "2px" }}>
          {(user?.role && user.role.name) || "Admin"}
        </span>
      </div>
    </div>
  );
};

export default ProfileView;
